import axios from "axios";

const API_KEY = process.env.REACT_APP_CRIC_API_KEY;

export const fetchLiveCricketMatches = async () => {
    try {
      const res = await axios.get(
        "https://api.cricapi.com/v1/currentMatches",
        {
          params: {
            apikey: process.env.REACT_APP_CRIC_API_KEY,
            offset: 0,
          },
        }
      );
  
      console.log("CRIC API RAW RESPONSE 👉", res.data);
  
      return res.data?.data || [];
    } catch (error) {
      console.error("Cricket API error", error);
      return [];
    }
  };

